export const WELCOME_TRANSLATE = {
    welcome: {
        breadcrumbName: "Welcome",
        actions: {
            continue: {
                text: "Continue"
            }
        },
        save: {
            form: {
                fields: {
                    acceptUseTerms: {
                        label: "I have read and agree to the terms above"
                    }
                }
            }
        }
    }
}
